export default __webpack_public_path__ + "files/534cc502825d6a944004fce3778fed69.mp3";